import styles from './InlineEventList.module.scss'
import { nanoid } from 'nanoid'
import { ClassNames } from 'services/classname.service'
import DateDisplay from 'basics/DateDisplay'

const InlineEventList = ({ className, events = [] }) => {
  const checkDate = (eventDate) => {
    const today = new Date()
    let show = false
    if(new Date(eventDate) >= today) {
      show = true
    }
    return show
  }
  return (
    <section className={styles['ds-inline-event-list']}>
      {events.map((event) => {
        return (
          <React.Fragment key={nanoid()}>
          {checkDate(event?.startDate) && (
            <div className={ClassNames([styles['ds-inline-event-list__event'], 'mb-2'])}>
              <div className={ClassNames([styles['ds-inline-event-list__event--meta'], 'mb-1'])}>
                <strong className="highlight">Event</strong>
                <span className="ml-1 mr-1">|</span>
                <DateDisplay dateString={event.startDate} dateFormat="MM.dd.yyyy" />
              </div>
              <strong className={styles['ds-inline-event-list__title']}>
                {event.pageBase && event.title && (
                  <a href={`/${event.pageBase[0].url}`} className="chevron">
                    {event.title}
                  </a>
                )}
              </strong>
            </div>
          )}
          </React.Fragment>
        )
      })}
    </section>
  )
}

InlineEventList.propTypes = {}

export default InlineEventList
